// Autogenerated
export const server = window.origin;
